<template>
  <div class='feature-toggle-disabled'>
    <div class='feature-toggle-disabled__header'>
      {{getTitle}}
    </div>
    <div class='feature-toggle-disabled__message'>
      {{getMessage}}
    </div>
    <lottie-animation
      ref="anim"
      :animationData="require('@/assets/icons/animations/contact.json')"
      :loop="true"
      class='feature-toggle-disabled__contact-animation'
    />
  </div>
</template>

<script>
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'FeatureToggleDisabled',
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    message: {
      type: String,
      required: true,
      default: '',
    },
  },
  components: {
    LottieAnimation,
  },
  computed: {
    getTitle() {
      return this.$t(this.title) || '';
    },
    getMessage() {
      return this.$t(this.message) || '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.feature-toggle-disabled {
  &__header,
  &__message {
    display: flex;
    justify-content: center;
    font-size: rem(30);
    margin: auto;
    overflow: hidden;
    text-transform: capitalize;
    color: var(--text-primary);
  }

  &__message {
    font-size: rem(20);
    text-transform: none;
    white-space: pre-line;
    text-align: center;
  }

  &__contact-animation {
    height: rem(300);
  }
}
</style>
